import React from 'react';
import { CodeBracketIcon, ServerIcon, ShieldCheckIcon, BoltIcon } from '@heroicons/react/24/outline';
import './Home.css';

function Home() {
  return (
    <div className="home-container">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content">
          <h1>Self-hosted WhatsApp REST API Integration</h1>
          <p className="hero-subtitle">
            Transform WhatsApp into a powerful REST API with complete control over your infrastructure and data security
          </p>
          <div className="hero-buttons">
            <a href="https://docs.whinself.app/docs/tutorials/quick-start" className="cta-button">Install App</a>
            <a href="#features" className="secondary-button">Learn More</a>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section id="features" className="features">
        <h2>Why Choose Whinself?</h2>
        <div className="features-grid">
          <div className="feature-card">
            <ServerIcon className="feature-icon" />
            <h3>On-Premise Solution</h3>
            <p>Deploy on your own infrastructure with complete control over your data and message flow. No cloud dependencies.</p>
          </div>
          <div className="feature-card">
            <CodeBracketIcon className="feature-icon" />
            <h3>RESTful API Integration</h3>
            <p>Industry-standard HTTP endpoints for messaging, group management, and media handling with comprehensive documentation.</p>
          </div>
          <div className="feature-card">
            <ShieldCheckIcon className="feature-icon" />
            <h3>Enterprise-Grade Security</h3>
            <p>Maintain WhatsApp's end-to-end encryption with your data never leaving your infrastructure.</p>
          </div>
          <div className="feature-card">
            <BoltIcon className="feature-icon" />
            <h3>Scalable Performance</h3>
            <p>Engineered for high-throughput messaging with minimal latency and reliable message delivery.</p>
          </div>
        </div>
      </section>

      {/* Code Example Section */}
      <section className="code-example">
        <h2>Simple REST API Integration</h2>
        <div className="code-container">
          <pre>
            <code>
{`# Send a WhatsApp message
curl -X POST http://your-server:3000/api/send \\
  -H "Content-Type: application/json" \\
  -d '{
    "to": "+1234567890",
    "message": "Hello from your secure WhatsApp API!"
  }'

# Create a WhatsApp group
curl -X POST http://your-server:3000/api/groups \\
  -H "Content-Type: application/json" \\
  -d '{
    "name": "Team Notifications",
    "participants": ["+1234567890", "+0987654321"]
  }'`}
            </code>
          </pre>
        </div>
      </section>

      {/* Use Cases Section */}
      <section className="use-cases">
        <h2>Enterprise Use Cases</h2>
        <div className="use-cases-grid">
          <div className="use-case">
            <h3>🤖 AI Integration</h3>
            <p>Build intelligent chatbots and automated response systems with your preferred AI platform.</p>
          </div>
          <div className="use-case">
            <h3>📊 Enterprise Systems</h3>
            <p>Seamlessly integrate WhatsApp with your CRM, ERP, and business workflows.</p>
          </div>
          <div className="use-case">
            <h3>🔔 Critical Alerts</h3>
            <p>Deploy reliable notification systems for mission-critical updates and alerts.</p>
          </div>
          <div className="use-case">
            <h3>🌐 Custom Solutions</h3>
            <p>Build tailored WhatsApp solutions for your specific business needs.</p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta">
        <h2>Ready to Get Started?</h2>
        <p>Download Whinself and deploy your secure, self-hosted WhatsApp API solution.</p>
        <div className="cta-buttons">
          <a href="https://docs.whinself.app/docs/tutorials/quick-start" className="cta-button">Install App</a>
          <a href="/pricing" className="secondary-button">View Pricing</a>
        </div>
      </section>
    </div>
  );
}

export default Home; 